import { css } from '@mui/material';
import { lightColorPalette } from '@/theme';

export const globalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Share+Tech+Mono&display=swap');

  body {
    font-family: Roboto, sans-serif;
    background: ${lightColorPalette.lbGreyDark};
    margin: 0;
    padding: 0;
  }

  /* Tablets */
  @media all and (max-width: 980px) {
    html,
    body {
      font-size: 8px;
    }
  }

  /* Desktop */
  @media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
    html,
    body {
      font-size: 10px;
    }
  }

  /* Retina */
  @media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi) {
    html,
    body {
      font-size: 11px;
    }
  }

  /* large screens */
  @media screen and (min-device-width: 1600px) {
    html,
    body {
      font-size: 13px;
    }
  }
`;
